export default __webpack_public_path__ + "static/media/9_2.f357eb00.png";